import {equals, isNotNil} from 'ramda';

import {GetWatermarkDetailResponseBody} from '@dms/api/sales';

import {WatermarkFormType} from '../types/WatermarkFormType';

/**
 * Decides whether saving the form changes what gets rendered into the ads, which is what triggers
 * the republish prompt (the name is not rendered, so it is not compared). A watermark with a
 * composition has no form image: the BE renders the scene and owns `fileId`, and it forces
 * position/size/fitToImage, so only the usage and the scene itself can change. Without a
 * composition the stored image and its placement are compared.
 */
export const isWatermarkBodyEqual = (
  form: WatermarkFormType,
  detail: GetWatermarkDetailResponseBody
): boolean => {
  const detailComposition = detail.composition ?? null;

  if (isNotNil(form.composition) || isNotNil(detailComposition)) {
    return form.usageType === detail.usageType && equals(form.composition, detailComposition);
  }

  return (
    form.usageType === detail.usageType &&
    (form.fileId?.id ?? null) === detail.fileId &&
    form.position === detail.position &&
    form.size === detail.size &&
    form.fitToImage === detail.fitToImage
  );
};
